import { LayoutGrid, List } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const DEFAULT_OPTIONS = [
  { value: 'card', label: 'Card view', icon: LayoutGrid },
  { value: 'list', label: 'Table view', icon: List },
];

export function ViewModeToggle({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  className,
}) {
  return (
    <div className={cn('inline-flex items-center rounded-lg bg-muted p-1', className)} aria-label="View mode">
      {options.map((option) => {
        const Icon = option.icon;
        const isActive = value === option.value;
        return (
          <Button
            key={option.value}
            type="button"
            variant={isActive ? 'secondary' : 'ghost'}
            size="sm"
            className={cn(
              'h-8 px-3',
              isActive ? 'bg-background text-foreground shadow-sm hover:bg-background' : 'text-muted-foreground'
            )}
            onClick={() => onChange(option.value)}
            aria-label={option.label}
            title={option.label}
          >
            <Icon className="h-4 w-4" />
          </Button>
        );
      })}
    </div>
  );
}
